import { render, staticRenderFns } from "./lowcode.vue?vue&type=template&id=77d89259&scoped=true&"
import script from "./lowcode.vue?vue&type=script&lang=js&"
export * from "./lowcode.vue?vue&type=script&lang=js&"
import style0 from "./lowcode.vue?vue&type=style&index=0&id=77d89259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d89259",
  null
  
)

export default component.exports